import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import injectTapEventPlugin from 'react-tap-event-plugin';
import configureStore from 'store/configureStore';
import Root from 'components/Root';
import { initiateInterceptor } from 'api/axios';

// Load SCSS
import 'assets/scss/app.scss';

// set initial state in store
const store = configureStore();

initiateInterceptor(store);
injectTapEventPlugin();

// Render it to DOM
render(
  <Provider store={ store }>
    <Root store={ store } />
  </Provider>,
  document.getElementById('root')
);
